export enum DelimeterType {
    CommaDelimeter = "comma",
    TabDelimeter = "tab",
}

export const delimeterTypeOptions = [
    { id: DelimeterType.CommaDelimeter, name: "Comma delimeter" },
    { id: DelimeterType.TabDelimeter, name: "Tab delimeter" },
];
